export default {
    '--full-color': '#4E0D15',
    '--light-color': 'rgba(78, 13, 21, 0.6)',
    '--main-content-grid': 'rgba(78,13,21,0.5)',
    '--grid-view-background': 'linear-gradient(180deg, #ffffff 0%, #ffffff 100%)',
    '--card-view-background': 'linear-gradient(180deg, #ffffff 0%, #ffffff 100%)',
    '--title-color': 'rgba(0, 0, 0, 0.87)',
    '--icon-color': '#4E0D15',
    '--grid-bg-color': 'rgba(209, 179, 153, 0.34)',
    '--text-input-bg-color': 'rgba(217,217,217,0.53)',
    '--avatar-background': 'linear-gradient(to right, rgba(209, 179, 153, 0.55), #D1B399)',
    '--reserve-background': 'linear-gradient(234deg, #4E0D15 20%, #70232A 100%)',
    '--icon-theme-filter': 'invert(10%) sepia(46%) saturate(4338%) hue-rotate(326deg) brightness(70%) contrast(105%)',
    '--login-layout-background': 'linear-gradient(234deg, #4E0D15 20%, #70232A 100%)',
    '--lbl-focused-color': '#4E0D15',
    '--focused-fieldset-color': 'rgba(78,13,21,0.5)',
    '--input-border-error-color': '#F04924',
    '--checkbox-color': '#4E0D15',
    '--color-white': '#ffffff',
    '--txt-disabled': '#ffffff',
    '--txt-success': '#4E0D15',
    '--txt-error': 'rgba(255,125,98,0.7)',
    '--disabled-bg': 'rgba(255,86,86,0.03)',
    '--txt-default': '#797979',
    '--link-color': '#4E0D15',
    '--txt-gray-color': '#797979',
    '--active-box-background': 'linear-gradient(180deg, #4E0D15 0%, #4E0D15 100%)',
    '--scrollbar-bg': 'linear-gradient(200deg, #4E0D15, #70232A)',
    '--active-item-background-color': 'rgba(209, 179, 153, 0.15)',
    '--input-number-border-color': '#D1B399',
    '--input-number-focused-border-color': '#4E0D15',
    '--btn-bg-hover': '#4E0D15',
    '--btn-success-background': 'linear-gradient(273.72deg, #4E0D15 5.88%, #70232A 128.9%)',
    '--btn-success-border-color': '#4E0D15',
    '--btn-gray-background-color': '#a4a4a4',
    '--btn-gray-border-color': '#aaaaaa',
    '--btn-disabled-border-color': '#e8e8e8',
    '--tab-background': 'linear-gradient(180deg, #4E0D15 0%, #4E0D15 100%)',
    '--tab-indicator-background': 'transparent',
    '--tab-shadow': '0 4px 8px 1px rgba(78, 13, 21, 0.08)',
    '--btn-shadow': '0 4px 18px 1px rgba(78, 13, 21, 0.18)',
    '--card-shadow': '0 4px 6px 0 rgba(78, 13, 21, 0.10)',
    '--input-background-color': '#F4ECE5',
    '--select-border-color': 'rgba(89,89,89,0.8)',
    '--select-bg-color': 'rgba(236,234,234,0.9)',
    '--select-text-color': 'rgba(0,0,0,0.9)',
    '--loading-color': '#4E0D15',
    '--redial-gradient': '#4E0D15',
}